module.exports = __webpack_public_path__ + "static/media/bellabyte-papelaria-administrativa-cartao-vista-papel-timbrado--768x591.aa3cf5cd.jpg";